<template>
	<div class="container back_tools_page">
		<PageTop></PageTop>
		
		<div style="position: relative;z-index: 9;width: 100%;height: 100%;padding-left: 220px;background: #f7f7f7;">
			<SideNavigation></SideNavigation>
			
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	import PageTop from "./components/page_top.vue"
	import SideNavigation from './components/side_navigation.vue'
	
	export default {
		components: {
			PageTop,
			SideNavigation
		}
	}
</script>

<style scoped>
	.back_tools_page{ padding: 50px 0 0 0; }
</style>
